<bt-loader [loaderId]="loaderId">
  @if(orderDetails.data){
  <ng-container>
    <div class="flex center margin-bottom">
      <button class="icon-button back-button flex-0 margin-right-x-small" (click)="onBack()">
        <i class="fa fa-chevron-left"></i>
      </button>
      <h4 class="flex-1">Order # {{orderNumber}} - {{orderDetails.orderStatus?.statusName}}</h4>
      <button class="flex-0" (click)="onOrderComments()"><i class="fa fa-comments"></i>Order comments</button>
    </div>

    <div class="flex">
      <div class="container-25 margin-right-small padding-right-small overflow mini custom-max-height">
        @for(item of orderDetails.dataToView; track item) {
        <div class="card flex center margin-bottom hover selectable"
          [ngClass]="{'active': orderDetails.selected && orderDetails.selected.modelId === item.modelId && orderDetails.selected.colorId === item.colorId && orderDetails.selected.sizeGroupId === item.sizeGroupId}"
          (click)="onSelectStyle(item)">
          <div class="flex-1 margin-right nowrap">
            <div class="padding-bottom-x-small truncate"><b>Code</b>: {{item.styleCode}}</div>
            <div class="padding-bottom-x-small truncate"><b>Name</b>: {{item.styleName}}</div>
            <div class="padding-bottom-x-small truncate"><b>Color</b>: {{item.colorCode}} - {{item.colorName}}</div>
            <div class="padding-bottom-x-small truncate"><b>Size group</b>: {{item.sizeGroupName || ' - All size groups - '}}</div>
            <div class="truncate"><b>Status</b>: {{item.styleStatus}}</div>
          </div>
        </div>
        }
      </div>

      @let selected = orderDetails?.selected;
      @if(selected){
        <div class="container-75">
          <div class="card">
            <h4 class="margin-bottom-small">{{selected.fullName}}</h4>
            <div class="flex">
              <div class="flex-1">
                <div class="margin-bottom-x-small"><b>Brand</b>: {{selected.brandName}}</div>
                <div class="margin-bottom-x-small"><b>Color code</b>: {{selected.colorCode}}</div>
                <div class="margin-bottom-x-small"><b>Photographer</b>: {{selected.photographerFullName}}</div>
                <div class="margin-bottom-x-small"><b>Size group</b>:
                  {{selected.sizeGroupName || ' - All size groups - '}}</div>
                <div class="margin-bottom-x-small"><b>Status</b>: {{selected.styleStatus}}</div>
              </div>
              <div class="flex-0 nowrap">
                <button class="margin-right" (click)="onStyleComments()"><i class="fa fa-comments"></i>Style shots
                  comments</button>
                <button [disabled]="disablePublishShots" (click)="onPublishShots()"><i class="fa fa-check"></i> Publish
                  shots</button>
              </div>
            </div>
            <div class="align-center">
              <h4 class="margin-bottom">Approved shots</h4>
              <div class="flex inline center margin-bottom-large">
                <div class="card flex">
                  @for(t of selected.shotTypes; track t) {
                  <div class="flex-1 margin-right-small margin-left-small">
                    <div class="margin-bottom-x-small bold">{{t.shotTypeCode}}</div>
                    <div class="margin-bottom-small">{{t.shotTypeName}}</div>
                    <div class="thumbnail big border" [ngClass]="{'empty': !t.shot}">
                      @if(t.shot){
                        <img [src]="t.shot.imgPath">
                      }
                    </div>
                  </div>
                  }
                </div>
              </div>
  
              @if(selected.shots?.length){
                <div class="full-width">
                  <h4 class="align-center margin-bottom">Uploaded shots</h4>
                  <div class="flex center full-width justify-center">
                    @for(s of selected.shots; track s) {
                    <div class="margin-left-x-small margin-right-x-small relative">
                      <div class="margin-bottom-x-small bold">
                        {{s.shotTypeCode}}
                      </div>
                      <div class="margin-bottom-small">
                        {{s.shotTypeName}}
                      </div>
                      <div class="thumbnail medium border">
                        <div class="img-container">
                          <img [preview]="s.shotTypeName" [src]="s.imgPath">
                          @if(s.shotApprovalStateId === shotStatusEnum.Rejected){
                            <div class="shot-icon rejected">
                              <i class="fa fa-thumbs-down margin-small" title="Rejected"></i>
                            </div>
                          }
                        </div>
                      </div>
                      <div class="actions flex center justify-around">
                        <i class="fa fa-thumbs-up margin-small primary" title="Approve"
                          [ngClass]="{'disabled': s.shotApprovalStateId !== shotStatusEnum.Uploaded}"
                          (click)="onPhotoAction(s, 'approve')"></i>
                        <i class="fa fa-thumbs-down margin-small red" title="Reject"
                          [ngClass]="{'disabled': s.shotApprovalStateId !== shotStatusEnum.Uploaded}"
                          (click)="onPhotoAction(s, 'reject')"></i>
                      </div>
                    </div>
                    }
                  </div>
                </div>
              }
            </div>
          </div>
        </div>
      }
    </div>
  </ng-container>
  }
</bt-loader>

@if(currentSidebarType === sidebarTypeEnum.orderComments){
  <bt-sidebar sidebarTitle="Order comments"
    (exit)="currentSidebarType = null">
    <bt-sidebar-comments [orderId]="orderId"></bt-sidebar-comments>
  </bt-sidebar>
}

@if(currentSidebarType === sidebarTypeEnum.shotsComments){
  <bt-sidebar sidebarTitle="Shots comments"
    (exit)="onExitSidebar()">
    <bt-sidebar-comments [style]="orderDetails.selected" [orderId]="orderId"></bt-sidebar-comments>
  </bt-sidebar>
}

@if(currentSidebarType === sidebarTypeEnum.customSidebar && !!tmpShot){
  <bt-sidebar [sidebarTitle]="photoAction + ' shot'" (exit)="onExitSidebar()">
    @if(tmpShot){
      <div class="flex overflow vertical">
        <div class="flex-0 padding-top-large padding-bottom-large">
          Are you sure you want to <b>{{photoAction}}</b> selected shot as <b>{{tmpShot.shotTypeName}}</b>?
        </div>
        <div class="flex-1 padding-bottom-large flex center justify-center sidebar-img-container">
          <img [src]="tmpShot.imgPath">
        </div>
        @if(photoAction === 'reject'){
          <div class="flex-0">
            <div class="margin-bottom-small">
              <textarea rows="4" placeholder="Type comment..." class="full-width" cols="50"
                [(ngModel)]="actionComments"></textarea>
            </div>
          </div>
        }
        <div class="flex-0">
          <button class="full-width" [loaderId]="sidebarLoaderId" [ngClass]="{'warning': photoAction === 'reject'}"
            (click)="onShotAction()">
            <i class="fa"
              [ngClass]="{'fa-thumbs-up': photoAction === 'approve', 'fa-thumbs-down': photoAction === 'reject'}"></i>
            {{photoAction}} shot
          </button>
        </div>
      </div>
    }
  </bt-sidebar>
}

@if(currentSidebarType === sidebarTypeEnum.customSidebar && !tmpShot){
  <bt-sidebar sidebarTitle="Publish shots"
    (exit)="onExitSidebar()">
    <div class="flex overflow vertical">
      <div class="flex-1 padding-top-large padding-bottom-large">
        <div class="margin-bottom-small">Are you sure you want to <b>publish shots</b>?</div>
        <div class="flex wrap">
          @for(t of orderDetails.selected.shotTypes; track t) {
          <div class="margin-top-small margin-right-small margin-left-small">
            <div class="margin-bottom-small bold">{{t.code}} - {{t.name}}</div>
            <div class="thumbnail big border" [ngClass]="{'empty': !t.shot}">
              @if(t.shot){
                <img [src]="t.shot.imgPath">
              }
            </div>
          </div>
          }
        </div>
      </div>
      <div class="flex-0 margin-bottom">
        <div class="margin-bottom-small">Pubblication date</div>
        <input type="date" class="full-width" [min]="todayDate" [(ngModel)]="pubblicationDate">
      </div>
      <div class="flex-0">
        <button class="full-width" [loaderId]="sidebarLoaderId" (click)="publishShots()">
          <i class="fa fa-check"></i>Publish shots
        </button>
      </div>
    </div>
  </bt-sidebar>
}